import { FormElementTag } from './FormElement';

export enum VisibilityRuleType {
    VisibilityRuleFormElement = 0,
    VisibilityRuleFormElementTag = 1,
}

interface VisibilityRuleData {
    'id': number | null;
    'operator': string;
    'weight': number;
    'valueOperator': string;
    'value': string;
    'target': string;
    '@type': string;
    'reportElement': string;
    'formElement': string;
    'formElementTag': string;
    'visibilityRuleSet': string;
}

export class VisibilityRule {
    id: number | null;
    visibilityRuleSet: string;
    operator: string;
    weight: number;
    valueOperator: string;
    value: string;
    type: string;

    formElement!: string;
    formElementTag!: string;

    constructor(data: VisibilityRuleData) {
        this.id = data.id;
        this.visibilityRuleSet = data.visibilityRuleSet;
        this.operator = data.operator;
        this.weight = data.weight;
        this.valueOperator = data.valueOperator;
        this.value = data.value;
        this.type = data['@type'];
        this.formElement = data.formElement;
        this.formElementTag = data.formElementTag;
    }
}

interface VisibilityRuleSetData {
    '@context': string;
    '@id': string;
    '@type': string;
    'id': number;
    'form': string;
    'formElement': string;
    'operator': string;
    'reportElement': string;
    'weight': number;
    'rules': VisibilityRuleData[];
}

export class VisibilityRuleSet {
    id: number | null;
    uri: string;
    parent: string;
    operator: string;
    weight: number;
    rules: VisibilityRule[] = [];
    newRuleType = 'form_element_rule';

    constructor(data: VisibilityRuleSetData) {
        this.id = data.id;
        this.uri = data['@id'];
        this.parent = data.formElement || data.reportElement;
        this.operator = data.operator;
        this.weight = data.weight;
        this.rules = Object.values(data.rules).map((d: any) => new VisibilityRule(d));
    }
}
